import React from 'react';
import { motion } from 'framer-motion';

const RoadmapSection = () => {
  const triggerModal = () => {
    window.dispatchEvent(new Event('openModal'));
  };

  const features = [
    { title: '90-Day Step-by-Step Plan:', description: 'Phase 1 (Foundation), Phase 2 (Analyst Skills), Phase 3 (Job Ready).' },
    { title: '5 Real-World Portfolio Projects:', description: 'Sales, HR Attrition, Marketing, Finance & Operations dashboards.' },
    { title: 'Resume & ATS Checklist:', description: 'Essential keywords and formatting to get noticed by US recruiters.' },
    { title: 'Salary Expectations (2026):', description: 'Detailed breakdown of Entry-Level ($55k-$75k) vs Mid-Level roles.' }
  ];

  return (
    <section className="py-20 bg-pbi-black animate-glow-border">
      <div className="container mx-auto px-6">
        <motion.div 
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="bg-gradient-to-r from-gray-900 to-black border border-gray-800 rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-12 relative overflow-hidden"
        >
          {/* Subtle Background Glow */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-pbi-yellow/5 blur-[100px] rounded-full"></div>
          
          <motion.div 
            initial={{ opacity: 0, x: -50, rotate: 3 }}
            whileInView={{ opacity: 1, x: 0, rotate: 3 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            whileHover={{ rotate: 0, scale: 1.05 }}
            className="md:w-1/3 relative"
          >
            <div className="bg-white text-black p-6 rounded shadow-[0_0_40px_rgba(255,255,255,0.1)] transform transition-transform duration-500 h-[400px] flex flex-col justify-between relative z-10 border-4 border-black">
              <div>
                <div className="font-bold text-2xl uppercase tracking-tighter mb-1">
                  Power BI
                </div>
                <div className="text-sm bg-black text-white inline-block px-2 py-1 mb-4">
                  Career Roadmap
                </div>
                <div className="h-1 w-20 bg-pbi-yellow mb-6"></div>
                <h2 className="text-4xl font-extrabold leading-none mb-4">
                  90-DAY <br/> LAUNCH <br/> PLAN
                </h2>
              </div>
              <div className="text-xs font-bold border-t border-gray-300 pt-4">
                By Fathy • 2026 Edition
              </div>
            </div>
            <motion.div 
              animate={{ scale: [1, 1.2, 1], opacity: [0.2, 0.4, 0.2] }}
              transition={{ duration: 4, repeat: Infinity }}
              className="absolute inset-0 bg-pbi-yellow blur-3xl -z-10"
            />
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            viewport={{ once: true }}
            className="md:w-2/3"
          >
            <h2 className="text-3xl font-bold mb-6">What's Inside The Free Guide?</h2>
            <ul className="space-y-4 mb-8">
              {features.map((feature, index) => (
                <motion.li 
                  key={index}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ delay: index * 0.1, duration: 0.6 }}
                  viewport={{ once: true }}
                  className="flex items-start gap-3"
                >
                  <div className="mt-1.5 flex-shrink-0">
                    <i className="fa-solid fa-check text-pbi-yellow" />
                  </div>
                  <span className="text-gray-300">
                    <strong className="text-white">{feature.title}</strong> {feature.description}
                  </span>
                </motion.li>
              ))}
            </ul>

            <motion.button 
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="inline-flex items-center gap-2 text-pbi-yellow font-bold border-b-2 border-pbi-yellow hover:text-white hover:border-white transition-all duration-300 pb-1"
              onClick={triggerModal}
            >
              Get Your Road Map
              <motion.i 
                animate={{ x: [0, 5, 0] }}
                transition={{ duration: 1.5, repeat: Infinity }}
                className="fa-solid fa-arrow-right"
              />
            </motion.button>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default RoadmapSection;